import React from 'react'

const HomeAdmin = () => {
  return (
    <div>HomeAdmin</div>
  )
}

export default HomeAdmin